import { render, staticRenderFns } from "./consum.vue?vue&type=template&id=d660d03c"
import script from "./consum.vue?vue&type=script&lang=js"
export * from "./consum.vue?vue&type=script&lang=js"
import style0 from "./consum.vue?vue&type=style&index=0&id=d660d03c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports